import SmallLogoFooter from '@gameday/common/components/form/Common/SmallLogoFooter'
import { formatDateTime } from '@gameday/common/formats/dateTime.jsx'
import Countdown from '@gameday/react-components/components/Countdown'
import Paper from '@gameday/react-components/components/Paper'
import STGTermsAndConditions from '@gameday/react-components/components/STGTermsAndConditions'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

const styles = theme => ({
  pageWrapper: {
    zIndex: 2,
    fontFamily: `'Barlow', sans-serif`,
    padding: 10,
    minHeight: 'initial',
    height: 'initial',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 1,
  },
  layout: {
    maxWidth: 600,
  },
  paper: {
    padding: '40px 40px',
    '& > *': {
      width: '100%',
      margin: 0,
    },
    minHeight: 300,
  },
  justifyCenter: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: 168,
    height: 168,
    marginBottom: 35,
    objectFit: 'cover',
  },
  iconEndFix: {
    position: 'absolute',
    right: 0,
    bottom: 5,
  },
  PageTitle: {
    color: theme.body.textColor,
    textAlign: 'center',
    margin: '30px 0',
    '& p': {
      color: theme.body.textColor,
      margin: 0,
      fontSize: 18,
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: '40px',
      [theme.breakpoints.down(700)]: {
        fontSize: 16,
      },
      [theme.breakpoints.down(400)]: {
        fontSize: 14,
      },
    },
  },
  countdownWrap: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& div': {
      fontSize: 18,
      color: theme.body.headingColor,
    },
  },
  dateTime: {
    margin: '40px',
    textAlign: 'center',
    '& p': {
      fontSize: 25,
      fontWeight: 500,
      margin: 0,
      color: theme.body.textColor,
      '&$date': {
        color: theme.body.textColor,
      },
      '&$time': {
        fontSize: 22,
      },
      [theme.breakpoints.down(700)]: {
        fontSize: 16,
        '&$time': {
          fontSize: 14,
        },
      },
      [theme.breakpoints.down(400)]: {
        fontSize: 14,
        '&$time': {
          fontSize: 12,
        },
      },
    },
  },
  date: {
    color: theme.body.textColor,
    fontSize: '18px !important',
  },
  dateEnd: {
    color: `${theme.body.headingColor} !important`,
    fontSize: '18px !important',
  },
  time: {},
  title: {
    font: theme.typography.defaultFont,
    fontSize: theme.typography.fontSizeLg,
    fontWeight: theme.typography.fontWeightBolder,
    margin: '0 0 16px 0',
    textAlign: 'center',
    '& p': {
      textAlign: 'center',
    },
    color: theme.body.textColor,
  },
  navLink: {
    textAlign: 'center',
    margin: '30px 0',
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
      texAlign: 'center',
      fontWeight: theme.typography.fontWeightBolder,
      fontSize: theme.typography.fontSizeSm,
    },
  },
  textBox: {
    textAlign: 'center',
    paddingTop: '2rem',
  },
  fullWidth: {
    width: '100%',
  },
  text: {
    fontSize: theme.typography.fontSizeSm,
    color: theme.body.textColorAlt,
  },
  soldOut: {
    fontSize: 18,
    color: theme.body.textColor,
    margin: '0px 8px 32px 8px',
    textAlign: 'center',
  },
})

function InitialPage({
  application,
  buttonBGColor,
  buttonLabel,
  buttonTextColor,
  classes,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  customWidth,
  logo,
  showTermsAndConditions,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  termsLogo,
  eventStartDate,
  eventEndDate,
  status,
  timezone,
  expired,
  countdownCompleteMessage,
  countdownCompletes,
  onCountdownComplete,
  soldOut,
  formType,
}) {
  const startDate = formatDateTime({
    returnDateOnly: true,
    style: 7,
    value: eventStartDate,
    timezone,
    inTimezone: true,
    showTimezone: true,
  })
  const endDate = formatDateTime({
    returnDateOnly: true,
    style: 7,
    value: eventEndDate,
    timezone,
    inTimezone: true,
    showTimezone: true,
  })

  return (
    <>
      <Paper
        application={application}
        width="100%"
        classes={{
          root: classes.pageWrapper,
          paper: classes.paper,
          layout: classes.layout,
        }}
      >
        <div className={classNames(classes.leftPanel, 'left-panel')}>
          <div className={classNames(classes.justifyCenter, 'logo-block')}>
            {
              // eslint-disable-next-line jsx-a11y/alt-text
              // biome-ignore lint/a11y/useAltText: TODO
              logo && <img className={classNames(classes.logo)} src={logo} />
            }
          </div>
        </div>
        <div className="divider" />
        <div className={classNames(classes.rightPanel, 'right-panel')}>
          {!expired && !soldOut && status === 'Active' ? (
            <div className={classes.countdownWrap}>
              {!countdownCompletes ? (
                <div className={classNames(classes.PageTitle)}>
                  <p>Registrations {formType === 'event' ? 'for this event' : ''} are currently closed.</p>
                  <p>They will open in:</p>
                </div>
              ) : null}
              <Countdown
                date={eventStartDate}
                timezone={timezone}
                dateFormat="YYYY-MM-DD HH:mm:ss"
                hideOnComplete
                completeMessage={countdownCompleteMessage}
                onComplete={onCountdownComplete}
                buttonBGColor={buttonBGColor}
                buttonLabel={buttonLabel}
                buttonTextColor={buttonTextColor}
                withButton
              />
              {!countdownCompletes && (
                <div className={classNames(classes.dateTime)}>
                  <p className={classNames(classes.date)}>{startDate}</p>
                </div>
              )}
            </div>
          ) : (
            <div className={classes.countdownWrap}>
              <div className={classNames(classes.title)}>
                <p>
                  {
                    // eslint-disable-next-line no-nested-ternary
                    soldOut
                      ? 'Sold Out!'
                      : formType === 'event'
                        ? 'Registrations for this event are closed.'
                        : 'Registrations are closed.'
                  }
                </p>
                {soldOut && (
                  <p className={classNames(classes.soldOut)}>Sorry, allocation has been exhausted for this event.</p>
                )}
              </div>
              {!soldOut && status === 'Active' ? (
                <div className={classNames(classes.dateTime)}>
                  <p className={classNames(classes.dateEnd)}>Registrations Ended:</p>
                  <p className={classNames(classes.dateEnd)}>{endDate}</p>
                </div>
              ) : null}
            </div>
          )}
          {showTermsAndConditions && <STGTermsAndConditions className="terms-block" showSignUp={false} />}
        </div>
      </Paper>
      <SmallLogoFooter />
    </>
  )
}

InitialPage.defaultProps = {
  application: '',
  buttonLabel: 'Refresh to open the form',
  customWidth: 400,
}

export default withStyles(styles)(InitialPage)
